<template>
  <div class="p-4 bg-danger-teres text-danger">
    {{ $t(i18nMessage) }}
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorMessage',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.error.unknown'
    }
  }
});
</script>
